
import { useState } from 'react';

export const useNewForm = (initialForm = {}) => {

    const [formState, setFormState] = useState(initialForm);

    const onInputChange = ({ target }) => {
        const { name, value } = target;

        setFormState(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const onMultipleInputChange = (fields) => {
        setFormState(prev => {
            const newFormState = { ...prev };

            fields.forEach(({ target }) => {
                const { name, value } = target;
                newFormState[name] = value;
            });

            return newFormState;
        });
    }

    const onResetForm = () => {
        setFormState(initialForm);
    }

    return {
        ...formState,
        formState,
        onInputChange,
        onMultipleInputChange,
        onResetForm,
    }
}
